import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Paper } from "@mui/material";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";

type CustomTooltipContentProps = {
  active?: boolean;
  payload?: any[];
};

export const CustomTooltipContent = (props: CustomTooltipContentProps) => {
  const { active, payload } = props;

  // console.log(
  //   "val here payload here check =>",
  //   payload?.[0]?.payload?.allAssessments
  // );

  if (!active || !payload || !payload.length) return null;

  return (
    <Paper
      sx={{
        maxHeight: "255px",
        overflow: "auto",
        overscrollBehavior: "contain",
      }}
    >
      <Text
        variant="subtitle2"
        fontWeight="600"
        mb={1}
        sx={{ borderBottom: "1px solid #e0e0e0", pb: 0.5 }}
      >
        {payload?.[0]?.payload?.displayDate}
      </Text>

      {payload?.[0]?.payload?.allAssessments?.map((item: any) => {
        return (
          <Box key={item.name}>
            <Flex alignItems="center" gap={0.5} mb={0.2}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                }}
              />
              <Text fontWeight="600">
                {item?.name} ({item?.Score || 0})
              </Text>
            </Flex>

            <Box sx={{ ml: 2.5 }}>
              {/* <Text color="text.secondary" mb={0.2}>
                Score: {item?.payload?.[item?.name]}
              </Text> */}

              <Flex alignItems="center" gap={0} mb={0.5}>
                <Flex alignItems="center" gap={0} mb={0.5}>
                  {item?.curScoreStatus !== null ? (
                    <Flex alignItems="center" gap={0.1}>
                      {item?.operation === "increase" ? (
                        <Flex gap={0.2}>
                          <ArrowUpwardIcon
                            sx={{ fontSize: 14, color: "#f44336" }}
                          />
                          <Text c="error" fontSize={"13px"}>
                            {item?.pointChange ?? ""}
                          </Text>
                          <sub>
                            <Text c="error" fontSize={"11px"}>
                              pts
                            </Text>
                          </sub>

                          <Text fontSize={"12px"}>
                            {item?.lastScore
                              ? `Since Last | Score ${item?.lastScore}`
                              : ""}
                          </Text>
                        </Flex>
                      ) : item?.operation === "decrease" ? (
                        <Flex gap={0.2}>
                          <ArrowDownwardIcon
                            color="success"
                            sx={{ fontSize: 14 }}
                          />
                          <Text c="green" fontSize={"13px"}>
                            {item?.pointChange ?? ""}
                          </Text>
                          <sub>
                            <Text color={"green"} fontSize={"11px"}>
                              pts
                            </Text>
                          </sub>

                          <Text fontSize={"12px"}>
                            {item?.lastScore
                              ? `Since Last | Score ${item.lastScore}`
                              : ""}
                          </Text>
                        </Flex>
                      ) : (
                        <RemoveIcon sx={{ fontSize: 14, color: "#9e9e9e" }} />
                      )}
                      {/* <Text
                        variant="body2"
                        sx={{
                          color:
                            item?.payload?.curScoreStatus === "INCREASE"
                              ? "#f44336"
                              : item?.payload?.curScoreStatus === "DECREASE"
                              ? "#4caf50"
                              : "#9e9e9e",
                        }}
                      >
                        {item?.payload?.operation ?? ""}
                      </Text> */}
                    </Flex>
                  ) : (
                    <Text variant="body2" color="text.disabled">
                      - since baseline
                    </Text>
                  )}
                </Flex>
              </Flex>

              <Text color="text.secondary" fontSize={"11px"}>
                {item?.attemptedQuestions} Qns filled out of{" "}
                {item?.totalQuestions}
              </Text>

              {/* <Text color="text.secondary" mt={0.5}>
                Patient: Ryan McCoy (Client)
              </Text> */}
            </Box>
          </Box>
        );
      })}
    </Paper>
  );
};
